import React, { useState, useEffect, useRef } from "react";
import GaugeComponent from "react-gauge-component"; // Import for GaugeComponent
import Common from "../../common/Common";
import { Box } from "@mui/material";
import "./cards.css";

// Phase Gauge Components (unchanged)
//...............................................................................................
const GaugeChartVoltage = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={0}
        maxValue={260}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} V` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} V`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 60 }, { value: 80 }, { value: 100 },
              { value: 120 }, { value: 140 }, { value: 160 }, { value: 180 }, { value: 200 },
              { value: 220 }, { value: 240 }, { value: 260 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#22d3ee"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartVoltage1 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={0}
        maxValue={260}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} V` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} V`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 60 }, { value: 80 }, { value: 100 },
              { value: 120 }, { value: 140 }, { value: 160 }, { value: 180 }, { value: 200 },
              { value: 220 }, { value: 240 }, { value: 260 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#22d3ee"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartVoltage2 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={0}
        maxValue={260}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} V` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} V`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 60 }, { value: 80 }, { value: 100 },
              { value: 120 }, { value: 140 }, { value: 160 }, { value: 180 }, { value: 200 },
              { value: 220 }, { value: 240 }, { value: 260 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#22d3ee"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartCurrent = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={0}
        maxValue={120}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} A` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} A`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 60 }, { value: 80 }, { value: 100 }, { value: 120 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#2563eb"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartCurrent1 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={0}
        maxValue={120}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} A` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} A`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 60 }, { value: 80 }, { value: 100 }, { value: 120 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#2563eb"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartCurrent2 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={0}
        maxValue={120}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} A` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} A`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 60 }, { value: 80 }, { value: 100 }, { value: 120 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#2563eb"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartPower = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        id="gauge-component-radial"
        value={metric}
        type="radial"
        minValue={0}
        maxValue={3000}
        arc={{
          width: 0.3,
          nbSubArcs: 20,
          colorArray: ["#5BE12C", "#EA4228"]
        }}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} W` },
          tickLabels: {
            type: "inner",
            valueConfig: { formatTextValue: (value) => `${value} W`, fontSize: 10 },
            ticks: [
              { value: 500 }, { value: 1000 }, { value: 1500 }, { value: 2000 }, { value: 2500 }
            ]
          }
        }}
        pointer={{
          length: 0.5,
          elastic: true,
          animationDelay: 0,
          color:"#5BE12C"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartPower1 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        id="gauge-component-radial"
        value={metric}
        type="radial"
        minValue={0}
        maxValue={3000}
        arc={{
          width: 0.3,
          nbSubArcs: 20,
          colorArray: ["#5BE12C", "#EA4228"]
        }}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} W` },
          tickLabels: {
            type: "inner",
            valueConfig: { formatTextValue: (value) => `${value} W`, fontSize: 10 },
            ticks: [
              { value: 500 }, { value: 1000 }, { value: 1500 }, { value: 2000 }, { value: 2500 }
            ]
          }
        }}
        pointer={{
          length: 0.5,
          elastic: true,
          animationDelay: 0,
          color:"#5BE12C"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartPower2 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        id="gauge-component-radial"
        value={metric}
        type="radial"
        minValue={0}
        maxValue={3000}
        arc={{
          width: 0.3,
          nbSubArcs: 20,
          colorArray: ["#5BE12C", "#EA4228"]
        }}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} W` },
          tickLabels: {
            type: "inner",
            valueConfig: { formatTextValue: (value) => `${value} W`, fontSize: 10 },
            ticks: [
              { value: 500 }, { value: 1000 }, { value: 1500 }, { value: 2000 }, { value: 2500 }
            ]
          }
        }}
        pointer={{
          length: 0.5,
          elastic: true,
          animationDelay: 0,
          color:"#5BE12C"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartFrequency = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={1}
        maxValue={99}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} Hz` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} Hz`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 45 }, { value: 50 },
              { value: 55 }, { value: 60 }, { value: 80 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#db2777"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartFrequency1 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={1}
        maxValue={99}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} Hz` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} Hz`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 45 }, { value: 50 },
              { value: 55 }, { value: 60 }, { value: 80 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#db2777"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

//...............................................................................................
const GaugeChartFrequency2 = ({ metric, lastUpdate }) => {
  return (
    <Box style={{ width: 200, height: 180 }}>
      <GaugeComponent
        value={metric}
        type="radial"
        minValue={1}
        maxValue={99}
        labels={{
          valueLabel: { formatTextValue: (value) => `${value.toFixed(1)} Hz` },
          tickLabels: {
            type: "outer",
            valueConfig: { formatTextValue: (value) => `${value} Hz`, fontSize: 10 },
            ticks: [
              { value: 20 }, { value: 40 }, { value: 45 }, { value: 50 },
              { value: 55 }, { value: 60 }, { value: 80 },
            ],
          },
        }}
        arc={{
          colorArray: ["#5BE12C", "#EA4228"],
          subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
          padding: 0.02,
          width: 0.3,
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color:"#db2777"
        }}
      />
      {lastUpdate && (
        <div className="text-xs text-center mt-1 text-gray-500">
          {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      )}
    </Box>
  );
};

// Main Component
//...............................................................................................
const Cards = () => {
  // State variables to hold real-time data
  const [gaugeValueV, setGaugeValueV] = useState(0);
  const [gaugeValueV1, setGaugeValueV1] = useState(0);
  const [gaugeValueV2, setGaugeValueV2] = useState(0);
  const [gaugeValueA, setGaugeValueA] = useState(0);
  const [gaugeValueA1, setGaugeValueA1] = useState(0);
  const [gaugeValueA2, setGaugeValueA2] = useState(0);
  const [gaugeValueW, setGaugeValueW] = useState(0);
  const [gaugeValueW1, setGaugeValueW1] = useState(0);
  const [gaugeValueW2, setGaugeValueW2] = useState(0);
  const [gaugeValueHz, setGaugeValueHz] = useState(0);
  const [gaugeValueHz1, setGaugeValueHz1] = useState(0);
  const [gaugeValueHz2, setGaugeValueHz2] = useState(0);
  
  // Connection and status states
  const [isConnected, setIsConnected] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('disconnected');
  const [lastUpdate, setLastUpdate] = useState(null);
  const [dataStats, setDataStats] = useState({
    receivedCount: 0,
    storageInterval: '1 minute'
  });

  // Refs for socket & retry timer
  const socketRef = useRef(null);
  const retryRef = useRef(null);
  const dataCountRef = useRef(0);

  // WebSocket connection for real-time data with reconnection logic
  useEffect(() => {
    let unmounted = false;

    const connect = () => {
      const url = process.env.REACT_APP_ENDPOINT_WS || "ws://localhost:5000";
      const socket = new WebSocket(url);
      socketRef.current = socket;

      socket.onopen = () => {
        console.log('WebSocket connected for 3-phase monitoring');
        setIsConnected(true);
        setConnectionStatus('connected');
        setDataStats(prev => ({ ...prev, receivedCount: 0 }));
        dataCountRef.current = 0;
      };

      socket.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          
          // Handle connection message
          if (message.type === 'connection') {
            console.log(`3-Phase Server info: Storage interval = ${message.interval}`);
            setDataStats(prev => ({ 
              ...prev, 
              storageInterval: message.interval || '1 minute' 
            }));
            return;
          }
          
          // Handle aggregated data notification (optional)
          if (message.type === 'aggregated' && message.dataType === 'power') {
            console.log('3-Phase Server stored aggregated data');
            return;
          }
          
          // Handle real-time data (this is what updates the gauges)
          if (message.type === 'realtime') {
            const newData = message;
            const now = new Date();
            setLastUpdate(now);
            dataCountRef.current += 1;
            
            // Update gauge values only if data is present (avoid resetting to 0)
            if (newData.voltage !== undefined) setGaugeValueV(newData.voltage);   
            if (newData.voltage1 !== undefined) setGaugeValueV1(newData.voltage1); 
            if (newData.voltage2 !== undefined) setGaugeValueV2(newData.voltage2);  
            if (newData.current !== undefined) setGaugeValueA(newData.current);  
            if (newData.current1 !== undefined) setGaugeValueA1(newData.current1); 
            if (newData.current2 !== undefined) setGaugeValueA2(newData.current2);   
            if (newData.power !== undefined) setGaugeValueW(newData.power);
            if (newData.power1 !== undefined) setGaugeValueW1(newData.power1); 
            if (newData.power2 !== undefined) setGaugeValueW2(newData.power2);       
            if (newData.frequency !== undefined) setGaugeValueHz(newData.frequency); 
            if (newData.frequency1 !== undefined) setGaugeValueHz1(newData.frequency1); 
            if (newData.frequency2 !== undefined) setGaugeValueHz2(newData.frequency2);
            
            // Update stats every 10 data points
            if (dataCountRef.current % 10 === 0) {
              setDataStats(prev => ({ 
                ...prev, 
                receivedCount: dataCountRef.current 
              }));
            }
          } 
          // Handle legacy format (for backward compatibility)
          else if (!message.type) {
            const newData = message;
            const now = new Date();
            setLastUpdate(now);
            dataCountRef.current += 1;
            
            // Update gauge values only if data is present (avoid resetting to 0)
            if (newData.voltage !== undefined) setGaugeValueV(newData.voltage);   
            if (newData.voltage1 !== undefined) setGaugeValueV1(newData.voltage1); 
            if (newData.voltage2 !== undefined) setGaugeValueV2(newData.voltage2);  
            if (newData.current !== undefined) setGaugeValueA(newData.current);  
            if (newData.current1 !== undefined) setGaugeValueA1(newData.current1); 
            if (newData.current2 !== undefined) setGaugeValueA2(newData.current2);   
            if (newData.power !== undefined) setGaugeValueW(newData.power);
            if (newData.power1 !== undefined) setGaugeValueW1(newData.power1); 
            if (newData.power2 !== undefined) setGaugeValueW2(newData.power2);       
            if (newData.frequency !== undefined) setGaugeValueHz(newData.frequency); 
            if (newData.frequency1 !== undefined) setGaugeValueHz1(newData.frequency1); 
            if (newData.frequency2 !== undefined) setGaugeValueHz2(newData.frequency2);
          }
        } catch (e) {
          console.error("Invalid WebSocket message format:", e);
          console.error("Raw message:", event.data);
        }
      };

      socket.onclose = (event) => {
        console.log(`3-Phase WebSocket disconnected: ${event.code} ${event.reason}`);
        setIsConnected(false);
        setConnectionStatus('disconnected');
        
        if (!unmounted) {
          // Exponential backoff for reconnection
          const delay = Math.min(30000, 5000 * Math.pow(1.5, dataCountRef.current % 10));
          console.log(`3-Phase: Attempting reconnect in ${delay/1000} seconds...`);
          retryRef.current = setTimeout(connect, delay);
        }
      };

      socket.onerror = (error) => {
        console.error("3-Phase WebSocket error:", error);
        setConnectionStatus('error');
        try {
          socket.close();
        } catch {}
      };
    };

    connect();

    return () => {
      unmounted = true;
      if (retryRef.current) clearTimeout(retryRef.current);
      if (socketRef.current && socketRef.current.readyState <= 1) {
        try {
          socketRef.current.close();
        } catch {}
      }
    };
  }, []);

  // Format connection status with colors
  const getStatusDisplay = () => {
    switch(connectionStatus) {
      case 'connected':
        return { text: 'Connected', color: 'text-green-500', bg: 'bg-green-500/10', border: 'border-green-500/20' };
      case 'disconnected':
        return { text: 'Disconnected', color: 'text-red-500', bg: 'bg-red-500/10', border: 'border-red-500/20' };
      case 'error':
        return { text: 'Connection Error', color: 'text-orange-500', bg: 'bg-orange-500/10', border: 'border-orange-500/20' };
      default:
        return { text: 'Connecting...', color: 'text-yellow-500', bg: 'bg-yellow-500/10', border: 'border-yellow-500/20' };
    }
  };

  const status = getStatusDisplay();

  return (
    <div className="p-4 md:p-6 bg-gradient-to-br from-gray-900 to-gray-800 min-h-screen">
      {/* Header with connection status */}
      <div className="mb-8 p-4 bg-gradient-to-r from-gray-800/50 to-gray-800/30 backdrop-blur-sm rounded-xl border border-gray-700">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-white mb-1">Three-Phase Power Monitoring</h1>
            <p className="text-gray-300">Real-time monitoring of all three electrical phases</p>
          </div>
          
          <div className="flex flex-wrap gap-4 items-center">            
            <div className="flex items-center gap-2 px-4 py-2 bg-gray-700/50 rounded-lg border border-gray-600">
              <svg className="w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              <span className="text-sm text-gray-300">
                Points: <span className="font-bold">{dataStats.receivedCount}</span>
              </span>
            </div>
            
            {lastUpdate && (
              <div className="flex items-center gap-2 px-4 py-2 bg-gray-700/50 rounded-lg border border-gray-600">
                <svg className="w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm text-gray-300">
                  Updated: {lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
            )}
          </div>
        </div> 
      </div>

      {/* Phase 1 */}
      <section className="cards grid3 mb-8">
        <div className="cardBox relative">        
          <Common title="Phase 1"/>
          <Box className="circle">
            <Box className="Phasetitle"></Box>
            <GaugeChartVoltage metric={gaugeValueV} lastUpdate={lastUpdate} />
            <GaugeChartCurrent metric={gaugeValueA} lastUpdate={lastUpdate} />
            <GaugeChartPower metric={gaugeValueW} lastUpdate={lastUpdate} />
            <GaugeChartFrequency metric={gaugeValueHz} lastUpdate={lastUpdate} />
          </Box>
          <div className="mt-4 p-3 bg-gray-800/50 rounded-lg">
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Voltage</div>
                <div className="text-white font-bold">{gaugeValueV.toFixed(1)} V</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Current</div>
                <div className="text-white font-bold">{gaugeValueA.toFixed(1)} A</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Power</div>
                <div className="text-white font-bold">{gaugeValueW.toFixed(1)} W</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Frequency</div>
                <div className="text-white font-bold">{gaugeValueHz.toFixed(1)} Hz</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Phase 2 */}
      <section className="cards grid3 mb-8">
        <div className="cardBox relative">     
          <Common title="Phase 2" />
          <Box className="circle">
            <Box className="Phasetitle"></Box>
            <GaugeChartVoltage1 metric={gaugeValueV1} lastUpdate={lastUpdate} />
            <GaugeChartCurrent1 metric={gaugeValueA1} lastUpdate={lastUpdate} />
            <GaugeChartPower1 metric={gaugeValueW1} lastUpdate={lastUpdate} />
            <GaugeChartFrequency1 metric={gaugeValueHz1} lastUpdate={lastUpdate} />
          </Box>
          <div className="mt-4 p-3 bg-gray-800/50 rounded-lg">
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Voltage</div>
                <div className="text-white font-bold">{gaugeValueV1.toFixed(1)} V</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Current</div>
                <div className="text-white font-bold">{gaugeValueA1.toFixed(1)} A</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Power</div>
                <div className="text-white font-bold">{gaugeValueW1.toFixed(1)} W</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Frequency</div>
                <div className="text-white font-bold">{gaugeValueHz1.toFixed(1)} Hz</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Phase 3 */}
      <section className="cards grid3 mb-8">
        <div className="cardBox relative">         
          <Common title="Phase 3" />
          <Box className="circle">
            <Box className="Phasetitle"></Box>
            <GaugeChartVoltage2 metric={gaugeValueV2} lastUpdate={lastUpdate} />
            <GaugeChartCurrent2 metric={gaugeValueA2} lastUpdate={lastUpdate} />
            <GaugeChartPower2 metric={gaugeValueW2} lastUpdate={lastUpdate} />
            <GaugeChartFrequency2 metric={gaugeValueHz2} lastUpdate={lastUpdate} />
          </Box>
          <div className="mt-4 p-3 bg-gray-800/50 rounded-lg">
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Voltage</div>
                <div className="text-white font-bold">{gaugeValueV2.toFixed(1)} V</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Current</div>
                <div className="text-white font-bold">{gaugeValueA2.toFixed(1)} A</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Power</div>
                <div className="text-white font-bold">{gaugeValueW2.toFixed(1)} W</div>
              </div>
              <div className="text-center p-2 bg-gray-700/30 rounded">
                <div className="text-gray-400">Frequency</div>
                <div className="text-white font-bold">{gaugeValueHz2.toFixed(1)} Hz</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Summary Panel */}
      <div className="mt-8 p-6 bg-gradient-to-r from-gray-800/60 to-gray-800/40 backdrop-blur-sm rounded-xl border border-gray-700">
        <h3 className="text-xl font-bold text-white mb-4">Three-Phase Summary</h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="p-4 bg-gray-800/50 rounded-lg">
            <div className="text-sm text-gray-400 mb-1">Average Voltage</div>
            <div className="text-2xl font-bold text-white">
              {((gaugeValueV + gaugeValueV1 + gaugeValueV2) / 3).toFixed(1)} V
            </div>
            <div className="text-xs text-gray-500 mt-2">
              Phase 1: {gaugeValueV.toFixed(1)} V
              <br />
              Phase 2: {gaugeValueV1.toFixed(1)} V
              <br />
              Phase 3: {gaugeValueV2.toFixed(1)} V
            </div>
          </div>
          
          <div className="p-4 bg-gray-800/50 rounded-lg">
            <div className="text-sm text-gray-400 mb-1">Total Current</div>
            <div className="text-2xl font-bold text-white">
              {(gaugeValueA + gaugeValueA1 + gaugeValueA2).toFixed(1)} A
            </div>
            <div className="text-xs text-gray-500 mt-2">
              Phase 1: {gaugeValueA.toFixed(1)} A
              <br />
              Phase 2: {gaugeValueA1.toFixed(1)} A
              <br />
              Phase 3: {gaugeValueA2.toFixed(1)} A
            </div>
          </div>
          
          <div className="p-4 bg-gray-800/50 rounded-lg">
            <div className="text-sm text-gray-400 mb-1">Total Power</div>
            <div className="text-2xl font-bold text-white">
              {(gaugeValueW + gaugeValueW1 + gaugeValueW2).toFixed(1)} W
            </div>
            <div className="text-xs text-gray-500 mt-2">
              Phase 1: {gaugeValueW.toFixed(1)} W
              <br />
              Phase 2: {gaugeValueW1.toFixed(1)} W
              <br />
              Phase 3: {gaugeValueW2.toFixed(1)} W
            </div>
          </div>
          
          <div className="p-4 bg-gray-800/50 rounded-lg">
            <div className="text-sm text-gray-400 mb-1">System Status</div>
            <div className={`text-2xl font-bold ${isConnected ? 'text-green-400' : 'text-red-400'}`}>
              {isConnected ? 'OPERATIONAL' : 'OFFLINE'}
            </div>
            <div className="text-xs text-gray-500 mt-2">
              Data Points: {dataStats.receivedCount}
              <br />
              Storage: {dataStats.storageInterval}
              <br />
              Last Update: {lastUpdate ? lastUpdate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'Never'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cards;